/* eslint-disable @typescript-eslint/no-explicit-any */

export default function isDiscreteScale(scaleConfig) {
  return scaleConfig?.type === 'band' || scaleConfig?.type === 'ordinal' || scaleConfig?.type === 'point';
}